import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createIndexedDbStorage } from '@/utils/storage/indexeddb-storage';
import { TTL } from '@/utils/storage/localStorage-with-ttl';

const useWishlistStore = create(
  persist(
    (set) => ({
      wishlist: [],
      addToWishlist: (sku) =>
        set((state) => {
          const normalizedSku = Array.isArray(sku) ? sku[0] : sku;
          if (state.wishlist.includes(normalizedSku)) return state; // already exists
          return { wishlist: [...state.wishlist, normalizedSku] };
        }),
      removeFromWishlist: (sku) =>
        set((state) => ({
          wishlist: state.wishlist.filter((info) => info !== sku),
        })),
      clearWishList: () => set({ wishlist: [] }),
    }),
    {
      name: 'wishlist',
      storage: createIndexedDbStorage('wishlist', TTL.ONE_WEEK),
    }
  )
);

export default useWishlistStore;
